import React from 'react';
import { Link } from 'react-router-dom';
import { FileTextIcon, UploadIcon, DollarSignIcon, BriefcaseIcon, TrashIcon, BrainIcon } from 'lucide-react';
interface Application {
  id: string;
  borrower: string;
  applicationId: string;
  borrowerPhoto?: string;
  [key: string]: any;
}
interface ApplicationSidebarProps {
  application: Application;
  activeTab: string;
  onTabChange: (tab: string) => void;
  onDeleteApplication: () => void;
}
export function ApplicationSidebar({
  application,
  activeTab,
  onTabChange,
  onDeleteApplication
}: ApplicationSidebarProps) {
  const tabs = [{
    id: 'details',
    label: 'Application Details',
    icon: <FileTextIcon className="h-5 w-5" data-id="element-107" />
  }, {
    id: 'documents',
    label: 'Documents',
    icon: <UploadIcon className="h-5 w-5" data-id="element-108" />
  }, {
    id: 'downPayment',
    label: 'Down Payment',
    icon: <DollarSignIcon className="h-5 w-5" data-id="element-109" />
  }, {
    id: 'income',
    label: 'Income',
    icon: <BriefcaseIcon className="h-5 w-5" data-id="element-110" />
  }, {
    id: 'rateAi',
    label: 'Rate AI',
    icon: <BrainIcon className="h-5 w-5" data-id="element-111" />
  }];
  return <div className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden" data-id="element-112">
      {/* Borrower header */}
      <div className="p-4 border-b border-neutral-200" data-id="element-113">
        <div className="flex items-center" data-id="element-114">
          {application.borrowerPhoto ? <div className="h-16 w-16 rounded-full overflow-hidden mr-3" data-id="element-115">
              <img src={application.borrowerPhoto} alt={application.borrower} className="h-full w-full object-cover" data-id="element-116" />
            </div> : <div className="h-16 w-16 rounded-full bg-neutral-200 flex items-center justify-center mr-3" data-id="element-117">
              <span className="text-neutral-500 text-lg font-medium" data-id="element-118">
                {application.borrower.charAt(0)}
              </span>
            </div>}
          <div data-id="element-119">
            <h2 className="text-lg font-medium text-neutral-900" data-id="element-120">
              {application.borrower}
            </h2>
            <p className="text-sm text-neutral-500" data-id="element-121">
              {application.applicationId}
            </p>
          </div>
        </div>
      </div>
      {/* Navigation tabs */}
      <nav className="p-2" data-id="element-122">
        <ul className="space-y-1" data-id="element-123">
          {tabs.map(tab => <li key={tab.id} data-id="element-124">
              <button className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md ${activeTab === tab.id ? 'bg-primary-50 text-primary-600' : 'text-neutral-700 hover:bg-neutral-50'}`} onClick={() => onTabChange(tab.id)} data-id="element-125">
                <span className="mr-3" data-id="element-126">{tab.icon}</span>
                {tab.label}
              </button>
            </li>)}
        </ul>
      </nav>
      {/* Links to other application sections */}
      <div className="p-2 border-t border-neutral-200" data-id="element-127">
        <Link to="/applications/documents" className="w-full flex items-center px-3 py-2 text-sm font-medium rounded-md text-neutral-700 hover:bg-neutral-50" data-id="element-128">
          <UploadIcon className="h-5 w-5 mr-3" data-id="element-129" />
          All Documents
        </Link>
      </div>
      {/* Delete application button */}
      <div className="p-3 mt-auto border-t border-neutral-200" data-id="element-130">
        <button onClick={onDeleteApplication} className="w-full flex items-center justify-center px-3 py-2 text-sm font-medium rounded-md text-danger-600 hover:bg-danger-50" data-id="element-131">
          <TrashIcon className="mr-2 h-4 w-4" data-id="element-132" />
          Delete Application
        </button>
      </div>
    </div>;
}